export default {
    googleMapAPI  : "AIzaSyAiTmoMnf8Qsut2ePCZwmKQVSSF-aNWel4",
    publicKeyAPI  : process.env.REACT_APP_TOKEN_SECRET_KEY,
    jwtSecret : "aNdRgUkXp2s5u8x/A?D(G+KbPeShVmYq",
}
